// extracted by mini-css-extract-plugin
export var btn = "recipeProductCard-module--btn--f7229";
export var button = "recipeProductCard-module--button--802bd";
export var buyButton = "recipeProductCard-module--buy-button--8d943";
export var cafeFormIntro = "recipeProductCard-module--cafe-form-intro--767c7";
export var card = "recipeProductCard-module--card--d9f79";
export var cardContainer = "recipeProductCard-module--card-container--57de6";
export var cardImage = "recipeProductCard-module--card-image--45a63";
export var cardTitle = "recipeProductCard-module--card-title--b4737";
export var cardWrapper = "recipeProductCard-module--card-wrapper--2c349";
export var highlight = "recipeProductCard-module--highlight--f061e";
export var rating = "recipeProductCard-module--rating--d4d5e";
export var redButton = "recipeProductCard-module--red-button--b7870";
export var redTransparentButton = "recipeProductCard-module--red-transparent-button--87569";
export var swiperContainer = "recipeProductCard-module--swiper-container--da8ef";
export var swiperProducts = "recipeProductCard-module--swiper-products--21509";
export var title = "recipeProductCard-module--title--83f64";
export var transparentButton = "recipeProductCard-module--transparent-button--2fdf1";
export var wrapper = "recipeProductCard-module--wrapper--ef5df";